import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
	Container,
	Row,
	Col,
	Card,
	CardBody,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Label,
	Button,
} from "reactstrap";
import { SuccessOk, SuccessCreated } from "configs/statusCode";
import {
	AvField,
	AvForm,
	AvCheckboxGroup,
	AvCheckbox,
} from "availity-reactstrap-validation";
import RolesService from "services/Admin/RolesService";
import { adminPrefix } from "configs/routePrefix";
import { toast } from "react-toastify";
import Language from "Enums/Language";
import CancelModal from "components/CancelModal";
import { useParams } from "react-router-dom";
import SuccessModal from "components/SucessModal";

const languages = ["en", "ar", "zh", "ru"];

const initialState = {
	en: "",
	ar: "",
	ru: "",
	zh: "",
};
const CreateRolePage = (props) => {
	const { id } = useParams();
	const [formData, setFormData] = useState(initialState);
	const [successModal, setSuccessModal] = useState(false);
	const rolesService = new RolesService();
	const [modal, setModal] = useState(false);
	const [loading, setLoading] = useState(false);
	const [permissions, setPermissions] = useState([]);

	const handleFieldChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleValidSubmit = (_, values) => {
		setLoading(true);
		const data = {
			name: { en: values.en },
			permission: permissions,
		};

		languages.forEach((language) => {
			if (values[language].length) {
				data.name[language] = values[language];
			}
		});
		if (id) {
			rolesService.update(id, data).then((res) => {
				if (res && res.status === SuccessOk) {
					// props.history.push(`${adminPrefix}/setting/roles`)
					// toast.success("Edited successfully")
					setSuccessModal(true);
				} else {
					setLoading(false);
				}
			});
		} else {
			rolesService.create(data).then((res) => {
				if (res && res.status === SuccessCreated) {
					// props.history.push(`${adminPrefix}/setting/roles`)
					// toast.success("New role has been added successfully")
					setSuccessModal(true);
				} else {
					setLoading(false);
				}
			});
		}
	};

	const checkBoxHaner = (e, type) => {
		const name = e.target.value;
		if (permissions.includes(`${e.target.value}`)) {
			setPermissions([...permissions.filter((per) => per != name)]);
		} else {
			setPermissions([...permissions.concat(`${e.target.value}`)]);
		}
	};

	useEffect(() => {
		if (id) {
			rolesService.find(id).then((res) => {
				if (res && res.status === SuccessOk) {
					setPermissions([...res.data.permissions]);
					setFormData((data) => {
						return {
							en: res.data.name.en,
							ar: res.data.name.ar,
							ru: res.data.name.ru,
							zh: res.data.name.zh,
						};
					});
				}
			});
		}
	}, []);
	return (
		<React.Fragment>
			<div className="page-content">
				<MetaTags>
					<title>{id ? "Edit User Role" : "Add New User Role"}</title>
				</MetaTags>
				<Container fluid>
					<Row>
						<h3>{id ? "Edit User Role" : "Add New User Role"}</h3>
					</Row>
					<AvForm
						className="form-horizontal"
						onValidSubmit={(e, v) => {
							handleValidSubmit(e, v);
						}}>
						<Card className="w-100 mt-2">
							<CardBody>
								<Row className="mb-1">
									{Language.LIST.map((lan, index) => {
										return (
											<Col md={6} key={index}>
												<AvField
													className="mb-2"
													name={lan.name}
													label={`User Role Name (${lan.name})`}
													bsSize="lg"
													value={formData[`${lan.name}`]}
													onChange={(e) => handleFieldChange(e)}
													required={lan.name === "en" ? true : false}
													errorMessage={"This field is required"}
													placeholder={
														lan.name === "en"
															? "English"
															: lan.name === "ar"
															? "العربية"
															: lan.name === "zh"
															? "中文"
															: "Русский"
													}
												/>
											</Col>
										);
									})}
								</Row>
							</CardBody>
						</Card>
						<Card className="w-100 mt-4">
							<CardBody>
								<Row className="mb-1">
									<h4>Permissions</h4>
								</Row>
								<Row className="mb-3">
									<AvCheckboxGroup inline name="dashboard">
										<Col md={12}>
											<Label className="mr-3">Dashboard</Label>
										</Col>
										<Col md={12}>
											<AvCheckbox
												className="mx-4"
												label="View"
												value="dashboard.view"
												checked={
													permissions.includes(`dashboard.view`) ? true : false
												}
												onChange={(e) => checkBoxHaner(e, "dashboard")}
											/>
										</Col>
									</AvCheckboxGroup>
								</Row>
								<hr />
								<Row className="mb-3">
									<AvCheckboxGroup inline name="admins">
										<Col md={12}>
											<Label className="mr-3">Manage Admins</Label>
										</Col>
										<Col md={12}>
											<AvCheckbox
												className="mx-4"
												label="View"
												value={`admins.view`}
												checked={
													permissions.includes(`admins.view`) ? true : false
												}
												onChange={(e) => checkBoxHaner(e, "admins")}
											/>
											<AvCheckbox
												className="mx-4"
												label="Invite"
												value={`admins.add`}
												checked={
													permissions.includes(`admins.add`) ? true : false
												}
												onChange={(e) => checkBoxHaner(e, "admins")}
											/>
											<AvCheckbox
												className="mx-4"
												label="Change Role"
												value={`admins.edit`}
												checked={
													permissions.includes(`admins.edit`) ? true : false
												}
												onChange={(e) => checkBoxHaner(e, "admins")}
											/>
											<AvCheckbox
												className="mx-4"
												label="Delete"
												value={`admins.delete`}
												checked={
													permissions.includes(`admins.delete`) ? true : false
												}
												onChange={(e) => checkBoxHaner(e, "admins")}
											/>
										</Col>
									</AvCheckboxGroup>
								</Row>
								<hr />
								<Row className="mb-3">
									<AvCheckboxGroup inline name="salesRep">
										<Col md={12}>
											<Label className="mr-3">Manage Sales Rep</Label>
										</Col>
										<Col md={12}>
											<AvCheckbox
												className="mx-4"
												label="View"
												value={`salesRep.view`}
												checked={
													permissions.includes(`salesRep.view`) ? true : false
												}
												onChange={(e) => checkBoxHaner(e, "salesRep")}
											/>
											<AvCheckbox
												className="mx-4"
												label="Invite"
												value={`salesRep.add`}
												checked={
													permissions.includes(`salesRep.add`) ? true : false
												}
												onChange={(e) => checkBoxHaner(e, "salesRep")}
											/>
											<AvCheckbox
												className="mx-4"
												label="Edit & Assign to Compounds and Areas"
												value={`salesRep.edit`}
												checked={
													permissions.includes(`salesRep.edit`) ? true : false
												}
												onChange={(e) => checkBoxHaner(e, "salesRep")}
											/>
											<AvCheckbox
												className="mx-4"
												label="Delete"
												value={`salesRep.delete`}
												checked={
													permissions.includes(`salesRep.delete`) ? true : false
												}
												onChange={(e) => checkBoxHaner(e, "salesRep")}
											/>
										</Col>
									</AvCheckboxGroup>
								</Row>
								<hr />
								<Row className="mb-3">
									<AvCheckboxGroup inline name="seller">
										<Col md={12}>
											<Label className="mr-3">Manage Clients</Label>
										</Col>
										<Col md={12}>
											<AvCheckbox
												className="mx-4"
												label="Add"
												value={`clients.add`}
												checked={
													permissions.includes(`clients.add`) ? true : false
												}
												onChange={(e) => checkBoxHaner(e, "clients")}
											/>
											<AvCheckbox
												className="mx-4"
												label="View"
												value={`clients.view`}
												checked={
													permissions.includes(`clients.view`) ? true : false
												}
												onChange={(e) => checkBoxHaner(e, "clients")}
											/>
											<AvCheckbox
												className="mx-4"
												label="Delete"
												value={`clients.delete`}
												checked={
													permissions.includes(`clients.delete`) ? true : false
												}
												onChange={(e) => checkBoxHaner(e, "clients")}
											/>
											<AvCheckbox
												className="mx-4"
												label="Edit"
												value={`clients.edit`}
												checked={
													permissions.includes(`clients.edit`) ? true : false
												}
												onChange={(e) => checkBoxHaner(e, "clients")}
											/>
										</Col>
									</AvCheckboxGroup>
								</Row>
								<hr />
								<Row className="mb-3">
									<AvCheckboxGroup inline name="seller">
										<Col md={12}>
											<Label className="mr-3">Manage Seller</Label>
										</Col>
										<Col md={12}>
											<AvCheckbox
												className="mx-4"
												label="View"
												value={`seller.view`}
												checked={
													permissions.includes(`seller.view`) ? true : false
												}
												onChange={(e) => checkBoxHaner(e, "seller")}
											/>
											<AvCheckbox
												className="mx-4"
												label="Delete"
												value={`seller.delete`}
												checked={
													permissions.includes(`seller.delete`) ? true : false
												}
												onChange={(e) => checkBoxHaner(e, "seller")}
											/>
											<AvCheckbox
												className="mx-4"
												label="Edit"
												value={`seller.edit`}
												checked={
													permissions.includes(`seller.edit`) ? true : false
												}
												onChange={(e) => checkBoxHaner(e, "seller")}
											/>
										</Col>
									</AvCheckboxGroup>
								</Row>
								<hr />
								<Row className="mb-3">
									<AvCheckboxGroup inline name="developers">
										<Col md={12}>
											<Label className="mr-3">Manage Developers</Label>
										</Col>
										<Col md={12}>
											<CheckBox
												checkBoxHaner={checkBoxHaner}
												list={permissions}
												type={"developers"}
											/>
										</Col>
									</AvCheckboxGroup>
								</Row>
								<hr />
								<Row className="mb-3">
									<AvCheckboxGroup inline name="interactive">
										<Col md={12}>
											<Label className="mr-3">Manage Rates</Label>
										</Col>
										<Col md={12}>
											<CheckBox
												checkBoxHaner={checkBoxHaner}
												list={permissions}
												type={"rate"}
											/>
										</Col>
									</AvCheckboxGroup>
								</Row>
								<hr />
								<Row className="mb-3">
									<AvCheckboxGroup inline name="compound">
										<Col md={12}>
											<Label className="mr-3">
												Manage Compounds & Buildings & Properties
											</Label>
										</Col>
										<Col md={12}>
											<CheckBox
												checkBoxHaner={checkBoxHaner}
												list={permissions}
												type={"compound"}
											/>
										</Col>
									</AvCheckboxGroup>
								</Row>
								<hr />
								<Row className="mb-3">
									<AvCheckboxGroup inline name="resale">
										<Col md={12}>
											<Label className="mr-3">Manage Resales</Label>
										</Col>
										<Col md={12}>
											<CheckBox
												checkBoxHaner={checkBoxHaner}
												list={permissions}
												type={"resale"}
											/>
										</Col>
									</AvCheckboxGroup>
								</Row>
								<hr />
								<Row className="mb-3">
									<AvCheckboxGroup inline name="payment">
										<Col md={12}>
											<Label className="mr-3">Manage Payment Plan</Label>
										</Col>
										<Col md={12}>
											<CheckBox
												checkBoxHaner={checkBoxHaner}
												list={permissions}
												type={"payment"}
											/>
										</Col>
									</AvCheckboxGroup>
								</Row>
								<hr />
								<Row className="mb-3">
									<AvCheckboxGroup inline name="interactive">
										<Col md={12}>
											<Label className="mr-3">Manage Interactive Mode</Label>
										</Col>
										<Col md={12}>
											<CheckBox
												checkBoxHaner={checkBoxHaner}
												list={permissions}
												type={"interactive"}
											/>
										</Col>
									</AvCheckboxGroup>
								</Row>
								<hr />
								<Row className="mb-3">
									<AvCheckboxGroup inline name="lead">
										<Col md={12}>
											<Label className="mr-3">Manage Leads</Label>
										</Col>
										<Col md={12}>
											<AvCheckbox
												className="mx-4"
												label="View"
												value={`lead.view`}
												checked={
													permissions.includes(`lead.view`) ? true : false
												}
												onChange={(e) => checkBoxHaner(e, "lead")}
											/>
											<AvCheckbox
												className="mx-4"
												label="Change Status"
												value={`lead.edit`}
												checked={
													permissions.includes(`lead.edit`) ? true : false
												}
												onChange={(e) => checkBoxHaner(e, "lead")}
											/>
											<AvCheckbox
												className="mx-4"
												label="Add Activity"
												value="lead.activity"
												checked={
													permissions.includes(`lead.activity`) ? true : false
												}
												onChange={(e) => checkBoxHaner(e, "lead")}
											/>
											<AvCheckbox
												className="mx-4"
												label="Add Feedback"
												value="lead.feedback"
												checked={
													permissions.includes(`lead.feedback`) ? true : false
												}
												onChange={(e) => checkBoxHaner(e, "lead")}
											/>
											<AvCheckbox
												className="mx-4"
												label="Add Deal"
												value="lead.deal"
												checked={
													permissions.includes(`lead.deal`) ? true : false
												}
												onChange={(e) => checkBoxHaner(e, "lead")}
											/>
											<AvCheckbox
												className="mx-4"
												label="Add Appointment"
												value="lead.appointment"
												checked={
													permissions.includes(`lead.appointment`)
														? true
														: false
												}
												onChange={(e) => checkBoxHaner(e, "lead")}
											/>
											<AvCheckbox
												className="mx-4"
												label="Add Resale"
												value="lead.resale"
												checked={
													permissions.includes(`lead.resale`) ? true : false
												}
												onChange={(e) => checkBoxHaner(e, "lead")}
											/>
											<AvCheckbox
												className="mx-4"
												label="Assign Sales Rep"
												value="lead.assign"
												checked={
													permissions.includes(`lead.assign`) ? true : false
												}
												onChange={(e) => checkBoxHaner(e, "lead")}
											/>
										</Col>
									</AvCheckboxGroup>
								</Row>
								<hr />
								<Row className="mb-3">
									<AvCheckboxGroup inline name="deal">
										<Col md={12}>
											<Label className="mr-3">Manage Deals</Label>
										</Col>
										<Col md={12}>
											<CheckBox
												checkBoxHaner={checkBoxHaner}
												list={permissions}
												type={"deal"}>
												<AvCheckbox
													className="mx-4"
													label="Add Activity"
													value="deal.activity"
													checked={
														permissions.includes(`deal.activity`) ? true : false
													}
													onChange={(e) => checkBoxHaner(e, "deal")}
												/>
												<AvCheckbox
													className="mx-4"
													label="Add Feedback"
													value="deal.feedback"
													checked={
														permissions.includes(`deal.feedback`) ? true : false
													}
													onChange={(e) => checkBoxHaner(e, "deal")}
												/>
											</CheckBox>
										</Col>
									</AvCheckboxGroup>
								</Row>
								<hr />
								<Row className="mb-3">
									<AvCheckboxGroup inline name="appointment">
										<Col md={12}>
											<Label className="mr-3">Manage Appointments</Label>
											<Col md={12}></Col>
											<CheckBox
												checkBoxHaner={checkBoxHaner}
												list={permissions}
												type={"appointment"}>
												<AvCheckbox
													className="mx-4"
													label="Add Feedback"
													value="appointment.feedback"
													checked={
														permissions.includes(`appointment.feedback`)
															? true
															: false
													}
													onChange={(e) => checkBoxHaner(e, "appointment")}
												/>
											</CheckBox>
										</Col>
									</AvCheckboxGroup>
								</Row>
								<hr />
								<Row className="mb-3">
									<AvCheckboxGroup inline name="crm">
										<Col md={12}>
											<Label className="mr-3">CRM</Label>
											<Col md={12}></Col>
											<AvCheckbox
												className="mx-4"
												label="CRM Button"
												value="crm.edit"
												checked={
													permissions.includes(`crm.edit`) ? true : false
												}
												onChange={(e) => checkBoxHaner(e, "crm")}
											/>
										</Col>
									</AvCheckboxGroup>
								</Row>
								<hr />
								<Row className="mb-3">
									<AvCheckboxGroup inline name="salesRep">
										<Col md={12}>
											<Label className="mr-3">Users Roles</Label>
										</Col>
										<Col md={12}>
											<CheckBox
												checkBoxHaner={checkBoxHaner}
												list={permissions}
												type={"role"}
											/>
										</Col>
									</AvCheckboxGroup>
								</Row>
								<hr />
								<Row>
									<AvCheckboxGroup inline name="setting" className="pt-3">
										<Row className="mb-3">
											<Col md={12}>
												<Label className="me-3">System Setting</Label>
											</Col>
											<Col md={12}>
												<CheckBox
													checkBoxHaner={checkBoxHaner}
													list={permissions}
													type={"setting"}
												/>
											</Col>
										</Row>
									</AvCheckboxGroup>
								</Row>
							</CardBody>
						</Card>
						<Row className="d-flex justify-content-between pb-4">
							<Col>
								<button
									className="btn btnUpload btnHeight px-4"
									onClick={() => {
										setModal(true);
									}}
									type="button"
									size={"lg"}>
									Cancel
								</button>
							</Col>
							<Col>
								<button
									type="submit"
									className="btn btn-success btnHeight px-4 float-end"
									size={"lg"}
									disabled={loading ? true : false}>
									Submit
								</button>
							</Col>
						</Row>
						<CancelModal
							modal={modal}
							setModal={setModal}
							goBackHandler={() =>
								props.history.push(`${adminPrefix}/setting/roles`)
							}
						/>
					</AvForm>
					<SuccessModal
						title={id ? "Edit User Role" : "Add New User Role"}
						modal={successModal}
						message={
							id
								? "User Role Edited Successfully"
								: "New User Role Added Successfully"
						}
						onClick={() => props.history.push(`${adminPrefix}/setting/roles`)}
					/>
				</Container>
			</div>
		</React.Fragment>
	);
};

const CheckBox = ({ type, list, checkBoxHaner, children }) => {
	return (
		<>
			<AvCheckbox
				className="mx-4"
				label="View"
				value={`${type}.view`}
				checked={list.includes(`${type}.view`) ? true : false}
				onChange={(e) => checkBoxHaner(e, type)}
			/>
			<AvCheckbox
				className="mx-4"
				label="Add"
				value={`${type}.add`}
				checked={list.includes(`${type}.add`) ? true : false}
				onChange={(e) => checkBoxHaner(e, type)}
			/>
			<AvCheckbox
				className="mx-4"
				label="Edit"
				value={`${type}.edit`}
				checked={list.includes(`${type}.edit`) ? true : false}
				onChange={(e) => checkBoxHaner(e, type)}
			/>
			<AvCheckbox
				className="mx-4"
				label="Delete"
				value={`${type}.delete`}
				checked={list.includes(`${type}.delete`) ? true : false}
				onChange={(e) => checkBoxHaner(e, type)}
			/>
			{children}
		</>
	);
};
export default CreateRolePage;
